<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  contacts.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : contacts.length
                }}
                of {{ contacts.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @keyup="delayedSearch"
          placeholder="Müşteri ara..."
        />
        <vs-button class="mb-4 md:mb-0 mr-4" @click.stop="showAddNew()"
          >Müşteri Ekle</vs-button
        >
      </div>

      <!-- prompt for addnew personnel -->

      <add-new-prompt
        :addnew="addNewRegister"
        :withAdditionalData="true"
        v-if="addNewRegister"
        @hideAddNewRegister="hideAddNew"
      ></add-new-prompt>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="ShowCustomerData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :rowClassRules="rowClassRules"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { repository } from "@/_services/repository.js";
import addNewPrompt from "./addNewPrompt.vue";

// Cell Renderer
import CellRendererLink from "./contactsListCellRenderer/CellRendererLink.vue";
import CellRendererStatus from "./contactsListCellRenderer/CellRendererStatus.vue";
import CellRendererActions from "./contactsListCellRenderer/CellRendererActions.vue";
import CellRendererTags from "./contactsListCellRenderer/CellRendererTags.vue";

export default {
  components: {
    AgGridVue,
    addNewPrompt,
    CellRendererLink,
    CellRendererStatus,
    CellRendererActions,
    CellRendererTags,
  },
  data() {
    return {
      addNewRegister: false,

      searchQuery: "",
      delayedSearchTimer: "",
      contacts: [],
      ShowCustomerData: [],
      gridApi: null,
      rowClassRules: null,
      gridOptions: { rowHeight: 40 },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      /* eslint-disable */
      columnDefs: [
        {
          headerName: "cId",
          field: "customerId",
          sort: "desc",
          filter: true,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: true,
        },
        {
          headerName: "Adı Soyadı",
          field: "firstName",
          filter: true,
          width: 200,
          cellRendererFramework: "CellRendererLink",
        },
        {
          headerName: "Telefon",
          field: "phone",
          filter: true,
          width: 150,
        },
        {
          headerName: "Email",
          field: "email",
          filter: true,
          width: 150,
          hide: true,
        },
        {
          headerName: "Etiket",
          field: "tags",
          filter: true,
          width: 250,
          cellRendererFramework: "CellRendererTags",
        },
        {
          headerName: "Bölge",
          field: "detailNote",
          filter: true,
          width: 150,
        },
        {
          headerName: "Müşteri Temsilcisi",
          field: "addUserID",
          filter: true,
          width: 150,
          hide: true,
        },

        {
          headerName: "Abonelik",
          field: "status",
          filter: true,
          width: 120,
          cellRendererFramework: "CellRendererStatus",
        },
        {
          headerName: "İşlem",
          field: "transactions",
          width: 120,
          cellRendererFramework: "CellRendererActions",
        },
      ] /* eslint-enable  */,
    };
  },

  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    showAddNew() {
      this.addNewRegister = true;
    },
    hideAddNew(d) {
      if (d) {
        this.contacts.push(d);
        this.ShowCustomerData(d);
      }
      this.addNewRegister = false;
    },

    getUsers: async function () {
      await repository
        .getAll("Customer/get?currentPage=0&pageSize=100")
        .then((r) => {
          this.contacts = r.list;
          this.ShowCustomerData = r.list;
        });
    },
    delayedSearch() {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(() => {
        if (
          (this.searchQuery && this.searchQuery.length > 3) ||
          this.searchQuery == ""
        )
          this.search();
      }, 500);
    },
    search: async function () {
      let r = await repository.getWithParam(
        "Customer/search",
        "searchQuery=" + this.searchQuery + "&currentPage=0&pageSize=100"
      );

      if (r && r.isSuccessful) {
        this.ShowCustomerData = r.list;
      } else this.ShowCustomerData = this.contacts;
    },
  },
  beforeMount() {
    this.rowClassRules = {
      rowColorForNotWorkingPerson: "data.status == false",
      rowColorForMissingInfoPerson: "data.error != null",
    };
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();
  },
  created() {
    this.getUsers().catch((err) => {
      console.error(err);
    });
  },
};
</script>


<style lang="scss" scoped>
.rowColorForNotWorkingPerson {
  background-color: rgb(255, 235, 235) !important;
}
.rowColorForMissingInfoPerson {
  background-color: rgba(255, 220, 196, 0.795) !important;
}
</style>

